import { useNotifications } from 'modules/notification/hooks/useNotifications';
import { useToast } from 'modules/toast/hooks/useToast';
import { newNotificationToast } from 'modules/toast/toastDictionary';
import { useTranslation } from 'react-i18next';
import { RealtimeAudienceEnum } from 'realtimer/realtimerAudiences';
import { useAuthStore } from 'shared/hooks/stores/useAuthStore';
import { useExpertProfileStore } from 'shared/hooks/stores/useExpertProfileStore';
import { useRealtimer } from 'shared/hooks/useRealtimer';
import { mapDtoToNotification } from 'types/Notification';
import { NotificationTypeEnum } from 'types/enums/notification-type.enum';
import { useDebouncedCallback } from 'use-debounce';

export const useNotificationRealtimer = () => {
  const { t } = useTranslation('notification');
  const expertId = useAuthStore((state) => state.user?.expertId)!;
  const firstName = useExpertProfileStore((state) => state.expertProfile?.firstName);
  const { refetchNotifications } = useNotifications();
  const { displayToast } = useToast();
  const debouncedRefetchNotifications = useDebouncedCallback(() => refetchNotifications(), 100);

  useRealtimer(
    RealtimeAudienceEnum.NotificationInserted,
    { expertId },
    (message) => {
      debouncedRefetchNotifications();

      const notification = message?.notification
        ? mapDtoToNotification(message.notification)
        : null;
      if (
        !notification ||
        notification.viewedAt ||
        !Object.values(NotificationTypeEnum).includes(notification.type)
      ) {
        return;
      }

      const { category, shortMessage } = t(notification.type, {
        returnObjects: true,
        interpolation: {
          escapeValue: false,
        },
        firstName,
        ...notification.metadata,
      }) as {
        category?: string;
        shortMessage?: string;
      };

      displayToast(newNotificationToast(category ?? t('newNotificationToastTitle'), shortMessage));
    },
    0,
  );
};
